// extracted by mini-css-extract-plugin
export var btnEventCard = "EventListItem-module--btn-event-card--DgBP2 EventCard-module--btn-event-card--8KISi";